'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormInput = require('./components/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _FormTextArea = require('./components/FormTextArea');

var _FormTextArea2 = _interopRequireDefault(_FormTextArea);

require('./contactform.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateEmail = function validateEmail(value) {
  var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(value);
};

var validatePhone = function validatePhone(value) {
  var phonePattern = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
  return phonePattern.test(value);
};

var ContactForm = function (_React$Component) {
  _inherits(ContactForm, _React$Component);

  function ContactForm() {
    _classCallCheck(this, ContactForm);

    var _this = _possibleConstructorReturn(this, (ContactForm.__proto__ || Object.getPrototypeOf(ContactForm)).call(this));

    _this.state = {
      about: '',
      name: '',
      email: '',
      phone: '',
      invalidAbout: false,
      invalidName: false,
      invalidEmail: false,
      invalidPhone: false,
      showSuccess: false,
      showError: false,
      showLoader: false
    };
    _this.onAboutChange = _this.onAboutChange.bind(_this);
    _this.onNameChange = _this.onNameChange.bind(_this);
    _this.onEmailChange = _this.onEmailChange.bind(_this);
    _this.onPhoneChange = _this.onPhoneChange.bind(_this);
    _this.onSubmit = _this.onSubmit.bind(_this);
    return _this;
  }

  _createClass(ContactForm, [{
    key: 'onAboutChange',
    value: function onAboutChange(e) {
      var isValid = e.target.value !== '';
      var aboutValidation = isValid ? { invalidAbout: !isValid } : {};
      this.setState(_extends({}, aboutValidation, { about: e.target.value }));
    }
  }, {
    key: 'onEmailChange',
    value: function onEmailChange(e) {
      /* onEmailChange sets invalidEmail only to false to prevent the
      error styling from appearing when the user starts typing. */
      var isValid = validateEmail(e.target.value);
      var emailValidation = isValid ? { invalidEmail: !isValid } : {};
      this.setState(_extends({}, emailValidation, { email: e.target.value }));
    }
  }, {
    key: 'onPhoneChange',
    value: function onPhoneChange(e) {
      /* onPhoneChange sets invalidPhone only to false to prevent the
      error styling from appearing when the user starts typing. */
      if (this.props.showPhone) {
        var isValid = validatePhone(e.target.value);
        var phoneValidation = isValid ? { invalidPhone: !isValid } : {};
        this.setState(_extends({}, phoneValidation, { phone: e.target.value }));
      } else {
        this.setState({ invalidPhone: false });
      }
    }
  }, {
    key: 'onNameChange',
    value: function onNameChange(e) {
      var isValid = e.target.value !== '';
      var nameValidation = isValid ? { invalidName: !isValid } : {};
      this.setState(_extends({}, nameValidation, { name: e.target.value }));
    }
  }, {
    key: 'onSubmit',
    value: function onSubmit() {
      var _this2 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _state = this.state,
          about = _state.about,
          name = _state.name,
          email = _state.email,
          phone = _state.phone;
      var _props = this.props,
          showTextArea = _props.showTextArea,
          submissionCallback = _props.submissionCallback;

      var invalidEmail = !validateEmail(email);
      var invalidPhone = !validatePhone(phone);
      var invalidAbout = showTextArea && about === '';
      var invalidName = name === '';
      if (invalidEmail || invalidName || invalidAbout || invalidPhone) {
        this.setState({
          invalidEmail: invalidEmail, invalidName: invalidName, invalidAbout: invalidAbout, invalidPhone: invalidPhone
        });
      } else {
        this.setState({ showLoader: true });
        e && e.target.blur();
        this.props.subscriptionCallback({
          about: about, name: name, email: email, phone: phone
        }).then(function () {
          _this2.toggleValidation('showSuccess');
          if (typeof submissionCallback === 'function') {
            submissionCallback();
          }
        }).catch(function () {
          return _this2.toggleValidation('showError');
        });
      }
    }
  }, {
    key: 'getValidationContent',
    value: function getValidationContent() {
      var showPhone = this.props.showPhone;
      var _state2 = this.state,
          invalidPhone = _state2.invalidPhone,
          invalidName = _state2.invalidName,
          invalidEmail = _state2.invalidEmail,
          showError = _state2.showError,
          showSuccess = _state2.showSuccess,
          showLoader = _state2.showLoader;

      if (showLoader) {
        return _react2.default.createElement(
          'div',
          { className: 'loader' },
          'One Moment Please',
          _react2.default.createElement(
            'span',
            null,
            '.'
          ),
          _react2.default.createElement(
            'span',
            null,
            '.'
          ),
          _react2.default.createElement(
            'span',
            null,
            '.'
          )
        );
      }

      if (invalidEmail) {
        return 'Invalid email';
      } else if (invalidName) {
        return 'Please enter name';
      } else if (showPhone && invalidPhone) {
        return 'Invalid phone';
      } else if (showError) {
        return 'Please Try Again!';
      } else if (showSuccess) {
        return 'Thank you!';
      }
      return 'Submit';
    }
  }, {
    key: 'toggleValidation',
    value: function toggleValidation(error) {
      var _extends2,
          _this3 = this;

      var resetText = error === 'showSuccess' || error === 'showError' ? {
        email: '', name: '', about: '', phone: ''
      } : {};
      this.setState(_extends({}, resetText, (_extends2 = {}, _defineProperty(_extends2, error, true), _defineProperty(_extends2, 'showLoader', false), _extends2)));
      if (error === 'showError') {
        setTimeout(function () {
          _this3.setState({ showError: false });
        }, 2500);
      } else {
        setTimeout(function () {
          _this3.setState({ showSuccess: false });
        }, 5000);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state3 = this.state,
          about = _state3.about,
          name = _state3.name,
          email = _state3.email,
          phone = _state3.phone,
          invalidAbout = _state3.invalidAbout,
          invalidName = _state3.invalidName,
          invalidEmail = _state3.invalidEmail,
          invalidPhone = _state3.invalidPhone,
          showError = _state3.showError,
          showSuccess = _state3.showSuccess;
      var _props2 = this.props,
          header = _props2.header,
          TOSLink = _props2.TOSLink,
          PPLink = _props2.PPLink,
          showTextArea = _props2.showTextArea,
          textAreaPlaceholder = _props2.textAreaPlaceholder,
          inline = _props2.inline,
          disabled = _props2.disabled,
          showPhone = _props2.showPhone;

      return _react2.default.createElement(
        'div',
        { id: inline ? 'contact-form-inline-container' : 'contact-form-container' },
        !inline && _react2.default.createElement(
          'h2',
          null,
          header
        ),
        !inline && showTextArea && _react2.default.createElement(_FormTextArea2.default, { invalid: invalidAbout, value: about, placeholder: textAreaPlaceholder, onChange: this.onAboutChange, disabled: disabled }),
        _react2.default.createElement(_FormInput2.default, { invalid: invalidName, value: name, placeholder: 'Name', onChange: this.onNameChange, onKeyPress: this.onSubmit, disabled: disabled }),
        _react2.default.createElement(_FormInput2.default, { invalid: invalidEmail, value: email, placeholder: 'Email', onChange: this.onEmailChange, onKeyPress: this.onSubmit, disabled: disabled }),
        showPhone && _react2.default.createElement(_FormInput2.default, { invalid: invalidPhone, value: phone, placeholder: 'Phone', onChange: this.onPhoneChange, onKeyPress: this.onSubmit, disabled: disabled }),
        !inline && (TOSLink || PPLink) && _react2.default.createElement(
          'div',
          { id: 'contact-form-agreement' },
          'By clicking Submit, I agree to the',
          TOSLink && _react2.default.createElement(
            'a',
            { href: TOSLink, target: '_blank', rel: 'noopener' },
            ' Terms of Service '
          ),
          TOSLink && PPLink && 'and',
          PPLink && _react2.default.createElement(
            'a',
            { href: TOSLink, target: '_blank', rel: 'noopener' },
            ' Privacy Policy'
          ),
          '.'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            {
              className: 'contact-form-submit-btn\n                        ' + (showError || invalidName || invalidEmail || invalidAbout ? 'contact-form-submit-btn-negative' : showSuccess ? 'contact-form-submit-btn-positive' : ''),
              onClick: function onClick() {
                return _this4.onSubmit();
              },
              disabled: disabled
            },
            this.getValidationContent()
          )
        )
      );
    }
  }]);

  return ContactForm;
}(_react2.default.Component);

exports.default = ContactForm;


ContactForm.propTypes = {
  subscriptionCallback: _propTypes2.default.func.isRequired,
  submissionCallback: _propTypes2.default.func,
  header: _propTypes2.default.string,
  TOSLink: _propTypes2.default.string,
  PPLink: _propTypes2.default.string,
  showTextArea: _propTypes2.default.bool,
  showPhone: _propTypes2.default.bool,
  textAreaPlaceholder: _propTypes2.default.string,
  inline: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};

ContactForm.defaultProps = {
  submissionCallback: null,
  header: 'Sign up for our services!',
  TOSLink: '',
  PPLink: '',
  showTextArea: false,
  showPhone: false,
  textAreaPlaceholder: 'Tell us more!',
  inline: false,
  disabled: false
};